import { GET, PATCH, POST, DELETE } from '../common/common.service'
import endpointsMutual from './endpoints'

const MutualsService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsMutual.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsMutual.BY_ID(id)),
  create: async (body) => POST(endpointsMutual.CREATE, body),
  update: async ({ _id, body }) => PATCH(endpointsMutual.UPDATE(_id), body),
  remove: async (id) => DELETE(endpointsMutual.REMOVE(id)),
}

export default MutualsService
